import { AppHelmet } from '@pendwa/common-browser/components/AppHelmet/index.js';
import { RedirectWithStatus } from '@pendwa/common-browser/components/RedirectWithStatus/index.js';
import { getAbsoluteUrlToSite } from '@pendwa/common-browser/utils/getAbsoluteUrlToSite.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Screen as NotFoundScreen } from '../../NotFound/index.js';
import { Screen as CreateScreen } from './screens/Create/index.js';
import { Screen as ForgotPasswordScreen } from './screens/ForgotPassword/index.js';
import { Screen as LoginScreen } from './screens/Login/index.js';
import { Screen as ResetPasswordScreen } from './screens/ResetPassword/index.js';

export function Screen() {
  return (
    <React.Fragment>
      <AppHelmet
        title={`Account | ${browserRootConfig.project.name}`}
        description={`Sign in or create account on ${browserRootConfig.project.name}.`}
        canonical_url={getAbsoluteUrlToSite(rootRoutes.app.account.main.get())}
      />
      <Switch>
        <Route exact path={rootRoutes.app.account.login.route} component={LoginScreen} />
        <Route exact path={rootRoutes.app.account.create.route} component={CreateScreen} />
        <Route exact path={rootRoutes.app.account.forgotPassword.route} component={ForgotPasswordScreen} />
        <Route exact path={rootRoutes.app.account.resetPassword.route} component={ResetPasswordScreen} />
        <RedirectWithStatus
          exact={true}
          from={rootRoutes.app.account.main.route}
          to={rootRoutes.app.account.login.get()}
          status={301}
        />
        <Route
          component={() => {
            return <NotFoundScreen />;
          }}
        />
      </Switch>
    </React.Fragment>
  );
}
